import { AccessControlSource } from "../model/types";
import { IS_ALLOWED_BY } from "./configs";

type Props = {
  activePages: Record<string, boolean>;
  page: { dataKey: string; isAllowedBy: AccessControlSource };
};

export const isPageDisabled = ({ activePages, page }: Props) => {
  if (!page) return true;
  if (!activePages) return false;
  const isAllowedByFrontend = page?.isAllowedBy === IS_ALLOWED_BY.FRONTEND;

  if (isAllowedByFrontend) return false;

  const isActivePagesAvailable = Object.keys(activePages)?.length !== 0;
  if (!isActivePagesAvailable) return false;

  const isDisabled = !activePages[page.dataKey];
  return isDisabled;
};
